/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Original_Language_LabelInputs */

const en_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original Language`)
};

const fr_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue d’origine`)
};

const de_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalsprache`)
};

const it_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua originale`)
};

const ru_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оригинальный язык`)
};

const es_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma original`)
};

const zh_cn2_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原文`)
};

const ja_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原文`)
};

const hi_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल भाषा`)
};

const pt_pt2_knp_guide_original_language_label = /** @type {(inputs: Knp_Guide_Original_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Língua original`)
};

/**
* | output |
* | --- |
* | "Original Language" |
*
* @param {Knp_Guide_Original_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_original_language_label = /** @type {((inputs?: Knp_Guide_Original_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Original_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_original_language_label(inputs)
	if (locale === "de") return de_knp_guide_original_language_label(inputs)
	if (locale === "it") return it_knp_guide_original_language_label(inputs)
	if (locale === "ru") return ru_knp_guide_original_language_label(inputs)
	if (locale === "es") return es_knp_guide_original_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_original_language_label(inputs)
	if (locale === "ja") return ja_knp_guide_original_language_label(inputs)
	if (locale === "hi") return hi_knp_guide_original_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_original_language_label(inputs)
	return en_knp_guide_original_language_label(inputs)
});